import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const MembershipsPageFooter = ({ itemVariants }) => (
  <motion.div
    className="text-center text-muted-foreground text-sm py-8 border-t border-border/20"
    variants={itemVariants}
  >
    <p>
      All plans include access to our seller dashboard and essential inventory
      management tools.
    </p>
    <p>
      For large-scale operations or custom requirements,{" "}
      <Link
        to="/enterprise-sales"
        className="text-primary underline hover:text-primary/80 transition-colors"
      >
        Contact our Enterprise Sales team
      </Link>
      .
    </p>
  </motion.div>
);

export default React.memo(MembershipsPageFooter);
